import { AuthenticationFederationType } from './authentication-federation-type';

export class FederationModel {
  code: string;
  type: AuthenticationFederationType;
}
